<template>
    <div class="app-container" ref="appRef">
        <div
                class="bigScreenMin"
                v-loading="loading"
                element-loading-text="Loading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <header>
                <div class="left">
                    <div style="margin-left: 10px; margin-top: 5px; margin-right: 10px">
                        <img :src="sysConfig.navLogo ? (baseUrl + sysConfig.navLogo) : '/static/img/indexLogo.png'"
                             style="width: 100%; max-width: 300px"/>
                    </div>
                </div>
                <div class="header_select">
                    <div class="header_center_title"> {{  stationName }} </div>

                </div>
                <div class="right">
                    <el-dropdown trigger="click" @command="handleCommand">
                        <img class="user" src="../../assets/img/user.png"/>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span>{{ userInfo.user_name }}</span>
                            </el-dropdown-item>
                            <el-dropdown-item divided command="1">
                                <span>{{$t('index.SystemSetting')}}</span>
                            </el-dropdown-item>
                            <el-dropdown-item command="3" v-if="userInfo.detail && userInfo.detail.defaultMainPage == 1">
                                <span>{{$t('index.SwitchHomePage')}}</span>
                            </el-dropdown-item>
                            <el-dropdown-item command="2">{{
                                $t("index.Logout")
                                }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <div @click="handleScreen" v-if="showFullScreen">
                        <img
                                class="full"
                                src="../../assets/img/unfull.png"
                                v-if="isFullScreen"
                        />
                        <img class="full" src="../../assets/img/full.png" v-else/>
                    </div>
                    <div style="position: relative">
                        <div id="he-plugin-simple"></div>
                        <div style="position: absolute; left: 0; top: 0; width: 100%; height: 100%"></div>
                    </div>

                    <!--          <img class="weather" src="../../assets/img/weather.png" />-->
                    <!--          <div class="city">{{ $t("index.city") }}</div>-->
                    <div class="timer">
                        <span>{{ time }}</span>
                    </div>
                </div>
            </header>
            <div class="main-container-page">
                <div class="top">
                    <div style="display: flex; justify-content: space-between">
                        <div class="panel_b" style="display: flex">
                            <div class="top_value_box">
                                <div class="top_value_title">{{$t('index.running_devices_no')}}</div>
                                <div class="top_value_value">{{powerData.runningEquip}}<span class="unit">{{$t('index.tai')}}</span></div>
                            </div>
                            <div class="top_value_box">
                                <div class="top_value_title">{{$t('index.save_electricity')}}</div>
                                <div class="top_value_value"><span class="unit" style="padding-left: 0; padding-right: 12px">￥</span>{{ formataVal(powerData.profit)}} </div>
                            </div>
                            <div style="position: absolute; border-right: 1px solid #7f7f7f; width: 0; left: 50%; height: 40%; top: 30%"></div>
                        </div>
                        <div class="panel_b" style="display: flex">
                            <div class="top_value_box">
                                <div class="top_value_title">{{$t('index.running_time')}}</div>
<!--                                <div class="top_value_value"><animate-number from="0" :to="powerData.runningDays" :key="powerData.runningDays" duration="2000" v-if="fresh"></animate-number><span class="unit">天</span></div>-->
                                <div class="top_value_value">{{powerData.runningDays}}<span class="unit">{{$t('index.days')}}</span></div>
                            </div>
                            <div class="top_value_box">
                                <div class="top_value_title">{{$t('index.system_efficiency')}}<div class="tips">{{$t('index.NOtoday')}}</div></div>

                                <div class="top_value_value">{{powerData.sysEfficiency}}<span class="unit">%</span></div>


                            </div>
                            <div style="position: absolute; border-right: 1px solid #7f7f7f; width: 0; left: 50%; height: 40%; top: 30%"></div>
                        </div>
                    </div>
                    <div style="display: flex; justify-content: space-between">
                        <div class="panel_b">
                            <div class="bottom_title">{{$t('index.charge_capacity')}}<div class="tips">{{$t('index.NOtoday')}}</div></div>
                            <div class="bottom_total_value">{{ formataVal(powerData.totalCharge)}}<span class="unit">kWh</span></div>
                            <div class="bottom_item_box" style="display: flex" v-if="false">
                                <div class="bottom_item">谷时<span class="bottom_item_value">{{ formataVal(powerData.gdTotalCharge)}}</span><span class="unit">kWh</span></div>
                                <div class="bottom_item">平时<span class="bottom_item_value">{{ formataVal(powerData.otherTotalCharge)}}</span><span class="unit">kWh</span></div>
                            </div>
                        </div>
                        <div class="panel_b">
                            <div class="bottom_title">{{$t('index.discharge_capacity')}}<div class="tips">{{$t('index.NOtoday')}}</div></div>
                            <div class="bottom_total_value">{{ formataVal(powerData.totalDischarge)}}<span  class="unit">kWh</span></div>
                            <div class="bottom_item_box" style="display: flex" v-if="false">
                                <div class="bottom_item">尖时<span  class="bottom_item_value">{{ formataVal(powerData.jdTotalDischarge)}}</span><span class="unit">kWh</span></div>
                                <div class="bottom_item">峰时<span  class="bottom_item_value">{{ formataVal(powerData.fdTotalDischarge)}}</span><span class="unit">kWh</span></div>
                            </div>
                        </div>
                    </div>
                    <div  class="gueChart" ref="gaugeChart">
                        <iframe width="100%" frameborder="0" scrolling="none" height="100%" src="/static/chart.html"  @load="onLoad" ref="frame"></iframe>
                        <div class="powerItem_right" :style="{ color: statusColor(runStatus)}">{{runStatus | statusFomat}}<i class="iconfont icon-chongdian"></i></div>
                        <div class="powerItem_left">{{pcsStatus2 | statusGridF}} / {{pcsStatus1 | statusF}}</div>
                    </div>
                </div>
                <div class="bottom">
                    <div style="position: absolute; width: 100%; left: 0; top: 0; display: flex; justify-content: space-between">
                        <div style="color: #0acfe6; font-size: 20px; margin: 10px">{{$t('index.Income')}}</div>
                        <el-dropdown style=" margin: 10px" trigger="click" @command="handleCommandChart">
                            <span class="el-dropdown-link" style="font-size: 16px;color: #0acfe6;">{{ command == 0 ? $t('index.last_week') : $t('index.last_month')}}<i class="el-icon-arrow-down el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="0">{{$t('index.last_week')}}</el-dropdown-item>
                                <el-dropdown-item command="1">{{$t('index.last_month')}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div style="margin-top: 40px;  width: 100%; height: 400px;" ref="energyChart"></div>
                </div>
            </div>
            <transition name="fade">
                <SystemSetting v-if="sysVis"></SystemSetting>
            </transition>
        </div>

    </div>
</template>

<script>
    import {fullscreenToggel, listenfullscreen} from "../../utils/util";
    import {setStore, getStore} from "@/utils/store";
    import moment from "moment";
    import {mapGetters} from "vuex";
    import drawMixin from "@/utils/drawMixin.js";
    import {refreshToken, getGuardChartData, getGuardData, sys, sysConfig, getTotalSOCAndStatus, getRunStatus} from "@/api/spms";
    import i18n from "@/lang";
    import SystemSetting from "@/view/SystemSetting/index";
    moment.locale("zh-cn", {
        weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
    });
    export default {
        name: "guestPage",
        mixins: [drawMixin],
        components: {SystemSetting},
        data() {
            return {
                loading: false,
                userInfo: getStore({name: "userInfo"}) || {},
                sysConfig: getStore({name: "systemSet"}) || {},
                baseUrl: imgBaseUrl,
                showFullScreen: true,
                isFullScreen: false,
                time: moment().format("YYYY-MM-DD HH:mm:ss"),
                energyChart: null,
                gaugeChart: null,
                powerData: {
                    totalCharge:"",
                    totalDischarge: "",
                    fdTotalDischarge: "",
                    gdTotalCharge: "",
                    jdTotalDischarge: "",
                    otherTotalCharge: "",
                    runningDays: 0,
                    sysEfficiency: 0.00,
                },
                sysVis: false,
                command: 1,
                timer: null,
                groupNo: null,
                stationName: '',
                fresh: true,
                runStatus: null,

                pcsStatus1: null,
                pcsStatus2: null,
                NumChangeTimer: null,
                refreshTimer: null,
            }
        },
        computed: {
            ...mapGetters(["language", "systemSet"]),

        },
        filters: {
            nullFormat(val){
                if(val === null || val === undefined){
                    return "--"
                }else {
                    return val
                }
            },
            statusFomat(val){
                if(val == -1){
                    return i18n.t("ems.LetStand")
                }else  if (val == 0){
                    return  i18n.t("ems.discharge")
                }else if(val == 1){
                    return i18n.t("ems.charging")
                }else{
                    return  i18n.t("ems.TheUnknown")
                }
            },
            statusF(val) {
                if (val == 0) {
                    return i18n.t("ems.Stop");
                } else if (val == 1) {
                    return i18n.t("ems.Waiting");
                } else if (val == 2) {
                    return i18n.t("ems.InService");
                } else  {
                    return i18n.t("status.unknown");
                }
            },

            statusGridF(val) {
                if (val == 1) {
                    return i18n.t("ems.offgrid");
                } else if (val == 0) {
                    return i18n.t("ems.interconnection");
                } else  {
                    return i18n.t("status.unknown");
                }
            },
        },
        provide() {
            return {
                getUserInfo: () => {
                    return {...this.userInfo}
                },
            };
        },
        created() {
            listenfullscreen(this.setScreen);
            this.refreshToken();
            this.getTime();

        },
        mounted(){
            this.initChart(this.command);
           // this.initGauge();
            sys().then(res => {
                const temp = res.data.data || [];
                if(temp.length > 0){
                    this.groupNo = temp[0].no;
                    this.stationName = this.language == 'zh' ? temp[0].stationName : ( temp[0].stationNameEn ? temp[0].stationNameEn : temp[0].stationName);
                    this.initData();
                    setTimeout(() => {
                        this.handleMqtt();
                    }, 3000);

                }
            });

        },
        methods: {
            handleMqtt(){
                const topic7 = "/"+this.wz+"/"+ this.groupNo +"/profit";
                window.mqttClient.subscribe(topic7, (error) => {
                    if (!error) {
                        console.log("Gateway service MQTT 订阅成功" + topic7);
                    } else {
                        console.log("MQTT 订阅失败");
                    }
                });
                // 接收消息处理


                const topic1 = "/profit/p31";
                const topic2 = "/profit/p7";
                window.mqttClient.subscribe(topic1, (error) => {if (!error) {
                    console.log("Gateway service MQTT 订阅成功" + topic1);
                } else {}});
                window.mqttClient.subscribe(topic2, (error) => {if (!error) {
                    console.log("Gateway service MQTT 订阅成功" + topic2);
                } else {}});
                window.mqttCallBack[topic7] = (message) => {
                    const temp = JSON.parse(message) || {};
                    if(temp.i === 'bmsUsage'){
                        const data = temp.d;
                        if(data.includes(',')){
                            const temp = data.split(",");
                            this.powerData = {runningEquip: temp[0], profit: temp[1], totalCharge: temp[2], runningDays: temp[3], sysEfficiency: temp[4], totalDischarge: temp[5]};
                            this.fresh = true;
                        }
                        console.log("收益:" + data);
                    }
                };
                window.mqttCallBack[topic1] = (message) => {
                    const data = JSON.parse(message) || {};
                    if(data.i === 'd' && this.command === 1){
                        let temp = data.d.reverse();
                        temp = temp.map(i => {
                            const item = i.split(',');
                            return { statisDate: item[0], profit: +item[1] }
                        });
                        this.initChartData(temp);
                    }
                };
                window.mqttCallBack[topic2] = (message) => {
                    const data = JSON.parse(message) || {};
                    if(data.i === 'd' && this.command === 0){
                        let temp = data.d.reverse();
                        temp = temp.map(i => {
                            const item = i.split(',');
                            return { statisDate: item[0], profit: +item[1] }
                        });
                        this.initChartData(temp);
                    }
                };
            },
            statusColor(val){
                if(val == -1){
                    return "#23c7e2"
                }else  if (val == 0){
                    return "#ffe80e"
                }else if(val == 1){
                    return "#40ff5b"
                }else{
                    return "#5c5d5d"
                }
            },
            handleCommand(command) {
                if (command == 1) {
                    this.openSysSet();
                } else if (command == 2) {
                    this.logout();
                } else if (command == 3) {
                    this.$router.push({path: "/index"});
                }
            },
            openSysSet() {
                this.sysVis = true;
            },
            handleScreen() {
                fullscreenToggel();
            },
            setScreen() {
                this.isFullScreen = !this.isFullScreen;
            },
            getTime() {
                setInterval(() => {
                    this.time = moment().format("YYYY-MM-DD HH:mm:ss");
                }, 1000);
            },
            initChart(type){
                let params;
                if(type == 0){
                    params= {
                        endDate: moment().format("YYYY-MM-DD"),
                        startDate: moment().subtract('W', 1).format("YYYY-MM-DD"),
                        size: 1000,
                        current: 1,
                    };
                }else if(type == 1){
                    params= {
                        endDate: moment().format("YYYY-MM-DD"),
                        startDate: moment().subtract('d', 31).format("YYYY-MM-DD"),
                        size: 1000,
                        current: 1,
                    };
                }
                getGuardChartData(params).then(res => {
                    if(res.data.data  ==  null) return;
                    let temp = res.data.data.reverse();
                    temp = temp.map(i => {
                        const item = i.split(',');
                        return { statisDate: item[0], profit: +item[1] }
                    });
                    this.initChartData(temp);
                }).catch(err => {
                    console.log(err);
                });
            },
            initChartData(temp){
                if(!this.energyChart && this.$refs.energyChart){
                    this.energyChart = this.$echarts.init(this.$refs.energyChart);
                }
                const option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        top: 40,
                        left: 60,
                        right: 60,
                        bottom: '5%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: temp.map(item => item.statisDate),
                            axisTick: {
                                alignWithLabel: true
                            },
                            axisLine: {
                                lineStyle: {
                                    color: '#ccc'
                                }
                            }
                        }
                    ],
                    yAxis: [
                        {
                            name: i18n.t("index.earnings"),
                            nameTextStyle: {
                                fontSize: 16,
                            },
                            type: 'value',
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: '#9d9ea0'
                                }
                            },

                            splitLine: {
                                lineStyle: {
                                    type: "dashed",
                                    color: "rgb(89, 89, 89)",
                                    // dashOffset: 10
                                },
                            },
                            show: true
                        }
                    ],
                    series: [
                        {
                            name: '收益',
                            type: 'bar',
                            barWidth: 16,
                            data: temp.map(item => item.profit),
                            itemStyle: {
                                normal: {
                                    barBorderRadius: 8,
                                    color: new this.$echarts.graphic.LinearGradient(
                                        0, 0, 0, 1,
                                        [
                                            {offset: 0, color: '#14c8d4'},
                                            {offset: 1, color: '#43eec6'}
                                        ]
                                    )
                                }
                            },
                        }
                    ]
                };
                this.energyChart.setOption(option);
            },
            onLoad() {
                this.$refs.frame.contentWindow.init(0);
                const timer = setInterval(() => {
                    if (this.groupNo == null) {
                        return;
                    } else {
                        getTotalSOCAndStatus(this.groupNo).then(res => {
                            const data = res.data.data;
                            if (data.includes(",")) {
                                const temp = data.split(',');
                                const capacity = { TAG_4E63: temp[1] };
                                this.runStatus = +capacity.TAG_4E63;
                                this.pcsStatus1 = +temp[2];
                                this.pcsStatus2 = +temp[3];
                                const UIP = { TAG_75E7: temp[0] };
                                if(UIP.TAG_75E7 && this.$refs.frame){
                                    this.$refs.frame.contentWindow.fresh(+UIP.TAG_75E7, +capacity.TAG_4E63);
                                }
                            }
                        });
                        this.NumChangeTimer = setInterval(() => {
                            getTotalSOCAndStatus(this.groupNo).then(res => {
                                const data = res.data.data;
                                if (data.includes(",")) {
                                    const temp = data.split(',');
                                    const capacity = { TAG_4E63: temp[1] };
                                    this.runStatus = +capacity.TAG_4E63;
                                    this.pcsStatus1 = +temp[2];
                                    this.pcsStatus2 = +temp[3];
                                    const UIP = { TAG_75E7: temp[0] };
                                    if(UIP.TAG_75E7 && this.$refs.frame){
                                        this.$refs.frame.contentWindow.fresh(+UIP.TAG_75E7, +capacity.TAG_4E63);
                                    }
                                }
                            });
                            // const a= (Math.floor(Math.random()*3))-1;
                            // this.runStatus = a;
                            // console.log(a)
                            // this.$refs.frame.contentWindow.fresh(40.2, a);
                        }, 3000);
                        clearInterval(timer);
                    }
                }, 200);
            },
            formataVal(num = 0) {
                if(num == null || num == undefined || num == "") return "--"
                const str = num.toString();
                const reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g :  /(\d)(?=(?:\d{3})+ $)/g;
                return str.replace(reg, "$1,")
            },
            logout() {
                this.$confirm(i18n.t("index.logoutTips"), i18n.t("index.Prompt"), {
                    confirmButtonText: i18n.t("index.Confirm"),
                    cancelButtonText: i18n.t("index.cancel"),
                    type: "warning",
                }).then(() => {
                    setStore({
                        name: "access_token",
                        content: "",
                        type: "session",
                    });
                    setStore({
                        name: "refresh_token",
                        content: "",
                        type: "session",
                    });
                    setStore({name: "userInfo", content: "", type: "session"});
                    window.mqttCallBack = {};
                    this.$router.push({path: "/login"});
                });
            },
            initData(){
                this.fresh = false;
                getGuardData(this.groupNo).then(respone => {
                    const data = respone.data.data;
                    if(data.includes(',')){
                        const temp = data.split(",");
                        this.powerData = {runningEquip: temp[0], profit: temp[1], totalCharge: temp[2], runningDays: temp[3], sysEfficiency: temp[4], totalDischarge: temp[5]};
                        this.fresh = true;
                    }
                }).catch(err => {
                    console.log(err);
                    this.fresh = true;
                })

                // getRunStatus(this.groupNo).then(res => {
                //     if(res && res.data && res.data.data){
                //         this.runStatus = res.data.data.cfStatus;
                //     }
                // });
                // getTotalSOCAndStatus(this.groupNo).then(res => {
                //     const data = res.data.data;
                //     if(data.includes(",")){
                //         const temp = data.split(',');
                //         const capacity = { cnsjrl: temp[0], TAG_4E63: temp[1]};
                //         this.runStatus = +capacity.TAG_4E63;
                //     }
                // });
            },
            handleCommandChart(val){
                this.command = val;
                this.initChart(val);
            },
            startNumChange(){
                if(this.NumChangeTimer) clearInterval(this.NumChangeTimer);
                this.NumChangeTimer = setInterval(() => {
                    const add  = Math.round(Math.random()*5) * 0.01;
                    this.powerData.profit =  ((+this.powerData.profit) + add).toFixed(2);
                }, 1000);
            },
            refreshToken() {
                this.refreshTimer = setInterval(() => {
                    const refresh_token = getStore({name: "refresh_token"}) || "";
                    refreshToken(refresh_token, "000000")
                        .then((response) => {
                            setStore({
                                name: "access_token",
                                content: response.data.access_token,
                                type: "session",
                            });
                            setStore({
                                name: "refresh_token",
                                content: response.data.refresh_token,
                                type: "session",
                            });
                        })
                        .catch((error) => {
                            this.$message.error(error);
                        });
                }, 30*60*1000);
            },
        },
        destroyed() {
            if(this.timer) clearInterval(this.timer)
            if(this.NumChangeTimer) clearInterval(this.NumChangeTimer)
            if(this.refreshTimer) clearInterval(this.refreshTimer);
        }
    }
</script>

<style scoped lang="scss">
    @import "../../styles/index";
    .header_center_title{
        font-size: 48px;
        color: var(--fontColor);
        letter-spacing: 5px;
        width: 800px;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
        text-align: center;
    }
    .main-container-page{
        width: 100%;
        //height: calc(100% - #{$header});
        height: 987px;
        background-image: url("/static/img/login_bg.jpg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        -moz-background-size: 100% 100%;
        overflow: hidden;
        position: relative;
        .top {
            height: calc(100% - 470px);
            position: relative;
            padding: 10px;
            box-sizing: border-box;
        }

        .bottom {
            height: 450px;
            padding: 10px;
            background-color: rgba(2,8,12,.6);
            border: 1px solid #595959;
            margin: 10px 20px 20px 20px;
            position: relative;
            box-sizing: border-box;
        }

        .panel{
            width: 360px;
            height: 260px;
            background-color: rgba(2,8,12,.6);
            border: 1px solid #595959;
            margin: 10px;
            position: relative;
            pointer-events: none;
        }
        .panel_b{
            height: 230px;
            width: 600px;
            background-color: rgba(2,8,12,.6);
            border: 1px solid #595959;
            margin: 10px;
            position: relative;
            color: white;
            pointer-events: none;
        }

        .gueChart {
            position: absolute;
            width: 900px;
            height: 700px;
            left: 514px;
            top: -71px;
            .powerItem_right{
                z-index: 1000;
                position: absolute;
                right: 140px;
                top:100px;
                color: #2aa415;
                line-height: 30px;
                font-size: 20px;
                .iconfont{
                    font-size: 24px;
                    margin-left: 15px;
                }
            }
            .powerItem_left{
                z-index: 1000;
                position: absolute;
                left: 140px;
                top:100px;
                color: #23c7e2;
                line-height: 30px;
                font-size: 20px;
                .iconfont{
                    font-size: 24px;
                    margin-left: 15px;
                }
            }
        }

        .bottom_title{
            width: 100%;
            text-align: center;
            font-size: 24px;
            margin-top: 50px;
            color: #c6c6c6;
            position: relative;
        }
        .bottom_total_value{
            width: 100%;
            text-align: center;
            font-size: 42px;
            margin-top: 50px;
            color: rgb(10, 207, 230);
            letter-spacing: 2px;
            font-weight: bold;
            font-family: 'digital-7', sans-serif;
            .unit{
                padding-left: 5px;
                font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
                font-weight: normal;
                color: #c6c6c6;
                font-size: 32px;
            }
        }
        .bottom_item_box{
            width: 100%;
            font-size: 24px;
            margin-top: 30px;
            display: flex;
            .bottom_item{
                width: 50%;
                color: #c6c6c6;
                text-align: center;
                .bottom_item_value{
                    color: rgb(10, 207, 230);
                    padding-left: 14px;
                }
                .unit{
                    padding-left: 5px;
                    font-weight: normal;
                    color: #c6c6c6;
                    font-size: 20px;
                }
            }
        }
        .tips{
            position: absolute;
            color: #919090;
            font-size: 16px;
            top: 35px;
            left: 0px;
            width: 100%;
        }

        .top_value_box{
            width: 50%;
            height: 100%;
            text-align: center;
            .top_value_title{
                color: #c6c6c6;
                font-size: 24px;
                margin-top: 50px;
                position: relative;


            }
            .top_value_value{
                color: rgb(10, 207, 230);
                font-size: 40px;
                margin-top: 40px;
                font-family: 'digital-7', sans-serif;
                .unit{
                    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
                    color: #c6c6c6;
                    font-size: 32px;
                    padding-left: 12px;
                }
            }
        }
    }
</style>